import { render, staticRenderFns } from "./accountRegistration.vue?vue&type=template&id=749a804e&scoped=true&"
import script from "./accountRegistration.vue?vue&type=script&lang=js&"
export * from "./accountRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a804e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749a804e')) {
      api.createRecord('749a804e', component.options)
    } else {
      api.reload('749a804e', component.options)
    }
    module.hot.accept("./accountRegistration.vue?vue&type=template&id=749a804e&scoped=true&", function () {
      api.rerender('749a804e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/accountRegistration.vue"
export default component.exports